import { render } from "./LegendList.vue?vue&type=template&id=eebf4420&scoped=true"
import script from "./LegendList.vue?vue&type=script&lang=js"
export * from "./LegendList.vue?vue&type=script&lang=js"

import "./LegendList.vue?vue&type=style&index=0&id=eebf4420&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eebf4420"]])

export default __exports__